import React from "react";
import { ListGroup } from "react-bootstrap";

const CustomMenuItem = React.forwardRef((props: any, ref: any) => (
  <ListGroup.Item className="border-0 pl-0" ref={ref}>{props.children}</ListGroup.Item>
));

export default CustomMenuItem;
